export default { sha: 'ae22f480046423dde6a54a7582cb172b894f4912', buildNumber: 'undefined' }
